import React, { useEffect, useState } from "react";

import _ from "lodash";
import cx from "classnames";

import styles from "./chat.module.scss";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useScrollToBottom, useSticky } from 'react-scroll-to-bottom';
import { Podcast, PodcastEditorChatState } from "src/types/coaching/podcast";
import { SimulationEditorChatState } from "src/types/coaching/simulation";
import { createPodcastEditorChat } from "src/redux/actions/coaching/podcast";


interface ChatContainerProps {
  podcast: Podcast;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({ podcast}) => {
  const dispatch = useDispatch();

  const scrollToBottom = useScrollToBottom();
  const [sticky] = useSticky();

  const { session, chats, creating, created, parameters } = useSelector((state: any) => {
    const editState = state.coaching.podcasts.edit;
    if (editState === null || editState.item?.id != podcast.id) {
      return {
        session: null,
        chats: []
      }
    }

    const sessionState = editState.editorSessions.find((session: any) => session.podcast === podcast.id);
    const session = sessionState?.session;
    const chats = sessionState?.chats || [];

    const lastChat = _.last(chats) as PodcastEditorChatState;
    const creating = lastChat?.creating || false;
    const created = lastChat?.created || false;
    const parameters = lastChat?.parameters || null;

    return {
      session: session,
      chats: chats,
      creating: creating,
      created: created,
      parameters: parameters,
    }
  });
  
  const [transcript, setTranscript] = useState({});

  const getParameters = () => {
    const lastChat = _.last(chats) as PodcastEditorChatState;
    return lastChat?.parameters || null;
  }

  const handleSubmit = (input: string) => {
    dispatch(createPodcastEditorChat({
      podcast: podcast.id!,
      session: session,
      input: input,
      parameters: getParameters(),
    }));
  }


  useEffect(() => {
    if(created && parameters != null) {
      // handleChange(parameters);
      // TODO -> find the topics and change the topic in the podcast
    }
  }, [created]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.chats}>
          {chats.map((chat: SimulationEditorChatState, index: number) => (
            <ChatView key={index} chat={chat} />
          ))}
        </div>

        <UserInput onSubmit={handleSubmit} />
      </div>
      {!sticky && (
        <div className={styles.downArrow} onClick={scrollToBottom}>
          <i className={cx(styles.icon, 'paperflite-down-arrow')} />
        </div>
      )}
    </>
  );
}

interface ChatViewProps {
  chat: SimulationEditorChatState;
}

const ChatView: React.FC<ChatViewProps> = ({ chat }) => {
  return (
    <div className={styles.chatView}>
      <div className={styles.userRequest}>
        {chat.input}
      </div>
      <div className={styles.aiResponse}>
        {chat.creating && 'processing your request...'}
        {chat.created && chat.output}
      </div>
    </div>
  );
}

interface UserInputProps {
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (input: string) => void;
}

const UserInput: React.FC<UserInputProps> = ({ disabled, onSubmit }) => {
  const [input, setInput] = React.useState("");
  const formRef = React.useRef<HTMLFormElement>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput(event.target.value);
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!disabled && input.trim() !== "") {
      onSubmit(input);
      setInput("");
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      formRef.current?.requestSubmit();
    }
  }

  return (
    <div className={styles.userInput}>
      <form ref={formRef} className={styles.form} onSubmit={handleSubmit}>
        <i className={cx(styles.icon, 'paperflite-seek')} />
        <input className={styles.input}
          placeholder="Try asking seek..."
          disabled={disabled}
          value={input}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
      </form>
    </div>
  );
}